import React, { Component } from "react";
import Helmet from "react-helmet";
import Layout from "../layout";
import { Link, graphql, StaticQuery } from "gatsby";
import SheltonCTSkylineLight from "../images/sila-life/connecticut/shelton-ct-line-drawing.svg";
import PostListing from "../components/Post/PostListing";
import BackgroundImage from "gatsby-background-image";
import SheltonPostings from "../components/Lever/SheltonPostings";
import config from "../../data/SiteConfig";

export default () => {
  return (
    <StaticQuery
      query={graphql`
        query {
          silaLife: allFile(
            filter: {
              relativeDirectory: { eq: "sila-life/connecticut" }
              extension: { ne: "svg" }
            }
          ) {
            edges {
              node {
                name
                childImageSharp {
                  fluid(quality: 100, maxWidth: 640) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
          }
        }
      `}
      render={data => {
        const silaLifePhotos = data.silaLife.edges.map(silaLifePhoto => {
          return {
            name: silaLifePhoto.node.name,
            fluid: silaLifePhoto.node.childImageSharp.fluid,
            path: silaLifePhoto.node.childImageSharp.fluid.src
          };
        });
        const silaCoffeeBreak = silaLifePhotos.find(
          silaLifePhoto => silaLifePhoto.name === "sila-coffee-break"
        ).path;
        const silaPaintNite = silaLifePhotos.find(
          silaLifePhoto => silaLifePhoto.name === "sila-ct-paint-nite"
        ).path;
        const silaSkiing = silaLifePhotos.find(
          silaLifePhoto => silaLifePhoto.name === "sila-goes-skiing-ct"
        ).path;
        const silaTulum = silaLifePhotos.find(
          silaLifePhoto => silaLifePhoto.name === "sila-in-tulum"
        ).path;
        const silaCornhole = silaLifePhotos.find(
          silaLifePhoto => silaLifePhoto.name === "sila-plays-cornhole"
        ).path;
        const silaPoolTournament = silaLifePhotos.find(
          silaLifePhoto => silaLifePhoto.name === "sila-pool-tournament"
        ).path;
        const silaStandingDesks = silaLifePhotos.find(
          silaLifePhoto => silaLifePhoto.name === "sila-working-standing-desks"
        ).path;
        const bagelsCoffee = silaLifePhotos.find(
          silaLifePhoto => silaLifePhoto.name === "bagels-coffee"
        ).path;
        const workout = silaLifePhotos.find(
          silaLifePhoto => silaLifePhoto.name === "workout"
        ).path;
        const gameControllers = silaLifePhotos.find(
          silaLifePhoto => silaLifePhoto.name === "game-controllers"
        ).path;
        const sandwich = silaLifePhotos.find(
          silaLifePhoto => silaLifePhoto.name === "sandwich"
        ).path;
        const lakeBg = silaLifePhotos.find(
          silaLifePhoto => silaLifePhoto.name === "shelton-lake-bg"
        ).fluid;
        // const postEdges = data.connecticutVideos.edges;
        return (
          <Layout>
            <>
              <Helmet
                title={`Sila Life in Shelton, CT | ${config.siteTitle}`}
              />
              <section className="location-graphic-header shelton">
                <img
                  className="location-graphic"
                  alt="A view of the New Haven, Connecticut skyline; just a short drive from Shelton"
                  src={SheltonCTSkylineLight}
                />
              </section>
              <section className="st-pad-vert">
                <div className="container text-center">
                  <div className="full">
                    <div className="restrict wide">
                      <h1>Sila Life in Shelton, CT</h1>
                      <p>
                        From tons of outdoor activities to trips to New York
                        City, our community has something for everyone. Located
                        at the crossroads of Connecticut’s main thoroughfares,
                        we are a short drive to the beach and less than two
                        hours from NYC. Jennings Beach is perfect for a summer
                        getaway. During the winter months, Mount Snow features
                        amazing slopes for ski and snowboard aficionados. Browse
                        our <a href="#openings">Shelton openings</a>.
                      </p>
                    </div>
                  </div>
                </div>
              </section>
              <section>
                <h2 className="h3 text-center">We Are Sila Shelton</h2>
                <div className="container make-block">
                  <div
                    className="culture-collage__two-thirds"
                    style={{
                      background: `url(${silaCornhole}) center center no-repeat`,
                      backgroundSize: `cover`
                    }}
                  />
                  <div
                    className="culture-collage__one-third"
                    style={{
                      background: `url(${silaPoolTournament}) center center no-repeat`,
                      backgroundSize: `cover`
                    }}
                  />
                  <div
                    className="culture-collage__one-third"
                    style={{
                      background: `url(${silaTulum}) center center no-repeat`,
                      backgroundSize: `cover`
                    }}
                  />
                  <div
                    className="culture-collage__two-thirds"
                    style={{
                      background: `url(${silaPaintNite}) center center no-repeat`,
                      backgroundSize: `cover`
                    }}
                  />
                  <div
                    className="culture-collage__one-third"
                    style={{
                      background: `url(${silaCoffeeBreak}) center center no-repeat`,
                      backgroundSize: `cover`
                    }}
                  />
                  <div
                    className="culture-collage__one-third"
                    style={{
                      background: `url(${silaSkiing}) center center no-repeat`,
                      backgroundSize: `cover`
                    }}
                  />
                  <div
                    className="culture-collage__one-third"
                    style={{
                      background: `url(${silaStandingDesks}) center center no-repeat`,
                      backgroundSize: `cover`
                    }}
                  />
                </div>
              </section>
              <h3 className="h2 text-center st-pad-top">A Day in the Life</h3>

              <section className="location-story shelton">
                <section className="dark-on-light st-pad-vert">
                  <div className="container">
                    <div className="story-caption">
                      <h3>Kickstart your day</h3>
                      <p>
                        Start the day with an early morning workout! Our on-site
                        facilities include a gym, tennis courts, and basketball
                        courts. Coffee lovers can stop at Three Bridges
                        Coffeehouse to help get a jump on the day or make an
                        espresso upon arriving at the office. And of course, we
                        love our Bagel Fridays!
                      </p>
                    </div>

                    <div className="story-illustration">
                      <img
                        alt="Cups of hot and iced coffee alongside a bagel with cream cheese"
                        src={bagelsCoffee}
                      />
                    </div>
                  </div>

                  <div className="cloud-border-top" />
                </section>

                <section>
                  <div className="container">
                    <div className="story-illustration">
                      <img
                        alt="Yoga mats alongside free weights in the office building gym"
                        src={workout}
                      />
                    </div>

                    <div className="story-caption">
                      <h3 className="light-blue-text">Take a break</h3>
                      <p>
                        Our team voted for a pool table during a recent
                        renovation and now you will see our team members
                        challenging each other to a quick game or longer
                        tournament. Others refocus with the help of a weekly
                        in-office yoga session.
                      </p>
                    </div>
                  </div>
                </section>

                <section className="light-on-dark xt-pad-vert">
                  <div className="cloud-border-bottom" />
                  <div className="container">
                    <div className="story-caption">
                      <h3>Our social side</h3>
                      <p>
                        For over five years, many of our Shelton team members
                        have eaten lunch together at the large farmhouse tables
                        in the kitchen. This consistent lunch bunch helps the
                        team recharge for the afternoon. For those without a bag
                        lunch for the day, we have two words: Super. Sandwich.
                        We have an unhealthy obsession with this amazing
                        sandwich shop down the road! We also love our Regional
                        Dinners, where we get together as a group in one of our
                        consultants' towns. With every rotation, some of us get
                        to explore a place we haven’t been, while others get to
                        hang out closer to home.
                      </p>
                    </div>

                    <div className="story-illustration">
                      <img
                        alt="A sandwich from a local shop is a popular choice for Sila team members who buy lunch before gathering in the kitchen to eat as a group"
                        src={sandwich}
                      />
                    </div>
                  </div>
                </section>
                <section className="light-on-dark no-marg-top xt-pad-vert">
                  <div className="container">
                    <div className="story-illustration">
                      <img
                        alt="Console controllers used for some friendly competition between coworkers at a Sila Shelton game night"
                        src={gameControllers}
                      />
                    </div>

                    <div className="story-caption">
                      <h3>Just for fun</h3>
                      <p>
                        We manage our valued work/life balance with several fun
                        Sila activities each month, and we like to have
                        something for everyone. Gamers can enjoy Nintendo Switch
                        nights, pool tournaments, and LAN parties. Get to know
                        your coworkers better after hours at a brewery happy
                        hour. For our right-brained crew, there are good times
                        to be had at Paint Nite (and we love putting our
                        masterpieces up around the office afterwards)!
                      </p>
                    </div>
                  </div>
                </section>
                <BackgroundImage
                  Tag="section"
                  fluid={lakeBg}
                  className="location-map st-pad-vert no-marg-top shelton-map-bg"
                >
                  <div className="container">
                    <div className="restrict wide text-center">
                      <h3>Our Location</h3>
                      <p>
                        We are located at{" "}
                        <a
                          href="https://goo.gl/maps/58M4gwqkDj42"
                          target="_blank"
                        >
                          2 Enterprise Drive, Suite 508, Shelton, CT 06484
                        </a>
                        .
                      </p>
                      <p>
                        If you're headed to our office for a visit, park in the
                        circle out front and take the elevator or lobby stairs
                        to the 5th floor. If you can’t find a spot in the
                        circle, just head around back to the parking garage.
                      </p>
                      <div className="responsive-map-embed">
                        <iframe
                          src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d47974.57082106005!2d-73.16001411497294!3d41.27816577216832!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x89e80a8d346812a3%3A0x399360e0ef479184!2s2+Enterprise+Dr+%23508%2C+Shelton%2C+CT+06484!3m2!1d41.2781066!2d-73.1249088!5e0!3m2!1sen!2sus!4v1534283424659"
                          width="600"
                          height="450"
                          frameborder="0"
                          style={{ border: 0 }}
                          allowfullscreen
                        />
                      </div>
                    </div>
                  </div>
                </BackgroundImage>
                <section id="openings">
                  <div className="container">
                    <div className="full restrict">
                      <h3 className="text-center margin-bottom">
                        Open Positions in Shelton
                      </h3>
                      <SheltonPostings />
                    </div>
                  </div>

                  <div className="container padding-top text-center">
                    <div className="full">
                      <p>
                        If you don't see a role that fits your profile, please{" "}
                        <a
                          href="https://jobs.lever.co/silasg/a71c995c-f564-4b04-8968-da6702c4d664/apply"
                          target="_blank"
                        >
                          submit a general application
                        </a>
                        .
                      </p>
                      <p>
                        <a
                          href="https://jobs.lever.co/silasg/a71c995c-f564-4b04-8968-da6702c4d664/apply"
                          target="_blank"
                          className="button primary"
                        >
                          Apply Now
                        </a>
                      </p>
                    </div>
                  </div>
                </section>
              </section>
            </>
          </Layout>
        );
      }}
    />
  );
};
